<script setup>
import JobReport from './job-report.vue'

definePage({
  meta: {
    subject: 'Job Reports',
  },
})
</script>

<template>
  <JobReport />
</template>
